const p = "@source-digital/sd-app-client-plugin-cross-storage", y = p;
export {
  y as CROSS_STORAGE_API,
  p as PLUGIN_ID
};
